<template>
  <div class="spreader_login"
    style="width: 100%; height:100%; display: flex;justify-content: center;align-items: center;">
    <div
      style="width: 600px; height: 550px; background: #FEFEFE;box-shadow: 0px 12px 32px 0px rgba(0, 56, 168, 0.2);border-radius: 40px;position: relative;">
      <div class="spreader_login_4"
        style="width:288px;height:72px;position: absolute; left: 25%;top: -30px;display: flex;justify-content: center;align-items: center;">
        <p style="font-size: 24px;font-family: Microsoft YaHei;font-weight: bold;color: #FFFFFF;">{{ title }}</p>
      </div>
      <div style="width: 100%;height:100%;margin-top: 10%;">
        <div v-if="status == 0 || status == 1"
          style="width: 100%;height:80px;display: flex;justify-content: center;align-items: center;">
          <div
            style="width: 50%;height: 100%;display: flex;justify-content: center;align-items: center;flex-direction: column;">
            <div class="spreader_login_1"
              style="display: flex;justify-content: center;align-items: center;flex-direction: column;cursor: pointer;">
              <p class="spreader_login_3" :style="codeLoginStyleConf" @click="setLoginStatus(0)">验证码登录</p>
              <p class="spreader_login_2" :style="codeLoginLineStyleConf"></p>
            </div>
          </div>
          <div
            style="width: 50%;height: 100%;display: flex;justify-content: center;align-items: center;flex-direction: column;">
            <div class="spreader_login_1"
              style="display: flex;justify-content: center;align-items: center;flex-direction: column;cursor: pointer;">
              <p class="spreader_login_3" :style="pwdLoginStyleConf" @click="setLoginStatus(1)">密码登录</p>
              <p class="spreader_login_2" :style="pwdLoginLineStyleConf"></p>
            </div>
          </div>
        </div>
        <div v-if="status == 0 || status == 1"
          style="width: 75%;height:400px;display: flex;align-items: center;flex-direction: column;margin: auto;">
          <!-- 手机号登录 -->
          <div v-if="status == 0" style="width: 100%;display: flex;align-items: center;flex-direction: column;">
            <el-input v-model="telValue" placeholder="手机号" style="width: 100%"></el-input>
            <div style="width: 100%;display: flex;align-items: center;flex-direction: row;margin-top: 20px;">
              <el-input v-model="code" placeholder="请输入手机验证码" style="width: 67%"></el-input>
              <el-button style="width: 30%;background: #8FCD5D;border-radius: 4px;margin-left: 3%;border: 0px;"
                @click="getTelCode(telValue)">{{ codeButtonStr }}</el-button>
            </div>
            <el-button style="width: 100%;height: 52px;font-size: 24px;font-family: Microsoft YaHei;font-weight: 400;
            color: #FFFFFF;margin-top: 35px;background: #347BFF;" @click="tellogin()">登录</el-button>
            <p style="width: 100%;display:block;font-size: 14px;font-family: Microsoft YaHei;font-weight: 400;
            color: #595959;margin: 10px 0 20px 0;padding: 0;cursor: pointer;" @click="setLoginStatus(4)">账号注册</p>
          </div>
          <!-- 手机密码 -->
          <div v-if="status == 1" style="width: 100%;display: flex;align-items: center;flex-direction: column;">
            <el-input v-model="telValue" placeholder="手机号" style="width: 100%"></el-input>
            <el-input type="password" v-model="pwd" placeholder="请输入密码" style="width: 100%;margin-top: 20px;">
            </el-input>
            <el-button plain style="width: 100%;height: 52px;font-size: 24px;font-family: Microsoft YaHei;font-weight: 400;
            color: #FFFFFF;margin-top: 35px;background: #347BFF;" @click="pwdlogin()">
              登录
            </el-button>
            <div style="width: 100%;display: flex;flex-direction: row;justify-content: space-between;">
              <p style="display:block;font-size: 14px;font-family: Microsoft YaHei;font-weight: 400;color: #595959;margin: 10px 0 20px 0;padding: 0;cursor: pointer;"
                @click="setLoginStatus(4)">账号注册</p>
              <p style="display:block;font-size: 14px;font-family: Microsoft YaHei;font-weight: 400;color: #595959;margin: 10px 0 20px 0;padding: 0;cursor: pointer;"
                @click="setLoginStatus(3)">忘记密码</p>
            </div>

          </div>
          <img width="64px" height="64px" src='../../assets/spreader/wechat.png' @click="setLoginStatus(2)"
            style="cursor:pointer;" />
          <p style="font-size: 14px;font-family: Microsoft YaHei;font-weight: 400;color: #7B7B7B;
          margin:10px 0 0 0;padding:0;cursor: pointer;" @click="setLoginStatus(2)">点击微信登录</p>
        </div>

        <!-- 微信登录 -->
        <div v-if="status == 2"
          style="width: 100%;height:100%;display: flex;align-items: center;flex-direction: column;">
          <div>
            <wxlogin appid="wx66d335d265a279b5" :scope="'snsapi_login'" :theme="'black'" :state="'state'"
              :redirect_uri='encodeURIComponent("https://uoofoxapp.ioofox.com/spreader/wxlogin")'
              rel="external nofollow">
            </wxlogin>
          </div>
          <p style="font-size: 20px;font-family: Microsoft YaHei;font-weight: 400;color: #D6D6D6;margin-top: 10px;">
            没有微信，<span style="color: #347BFF;cursor: pointer;" @click="setLoginStatus(0)">手机号登录</span>
          </p>
        </div>
        <!-- 忘记密码 -->
        <div v-if="status == 3"
          style="width: 75%;height:400px;display: flex;align-items: center;flex-direction: column;margin: auto;">
          <el-input type="number" v-model="telValue" placeholder="手机号" style="width: 100%;"></el-input>
          <div style="width: 100%;display: flex;align-items: center;flex-direction: row;margin-top: 20px;">
            <el-input type="number" v-model="forgetPwdCode" placeholder="请输入手机验证码" style="width: 67%"></el-input>
            <el-button style="width: 30%;background: #8FCD5D;border-radius: 4px;margin-left: 3%;border: 0px;"
              @click="getTelCode(telValue)">{{ codeButtonStr }}</el-button>
          </div>
          <el-input v-model="forgetPwdPwd" placeholder="请输入密码" style="width: 100%;margin-top: 36px;" show-password>
          </el-input>
          <p style="display:block;width:100%;font-size: 16px;font-family: Microsoft YaHei;font-weight: 400;color: #347BFF;cursor: pointer;"
            @click="setLoginStatus(0)">返回登陆</p>

          <el-button plain style="width: 100%;height: 52px;
          font-size: 24px;font-family: 
          Microsoft YaHei;font-weight: 400;color: #FFFFFF;
          margin-top: 35px;background: #347BFF;" @click="clickeUpdatePwd">
            确认修改
          </el-button>
        </div>
        <!-- 账号注册 -->
        <div v-if="status == 4"
          style="width: 75%;height:400px;display: flex;align-items: center;flex-direction: column;margin: auto;">
          <el-input type="number" v-model="telValue" placeholder="手机号" style="width: 100%;"></el-input>
          <div style="width: 100%;display: flex;align-items: center;flex-direction: row;margin-top: 20px;">
            <el-input type="number" v-model="registerCode" placeholder="请输入手机验证码" style="width: 67%"></el-input>
            <el-button style="width: 30%;background: #8FCD5D;border-radius: 4px;margin-left: 3%;border: 0px;"
              @click="getTelCode(telValue)">{{ codeButtonStr }}</el-button>
          </div>
          <el-input v-model="registerPwd" placeholder="请输入密码" style="width: 100%;margin-top: 36px;" show-password>
          </el-input>
          <el-checkbox v-model="agreementChecked" style="width:100%;margin-top: 30px;font-size: 14px;
          font-family: Microsoft YaHei;font-weight: 400;color: #D6D6D6;" @change="selectProtocolBox">
            我与阅读并接受
            <router-link to="privacyPolicy" style="color: #333333;text-decoration: none;" exact>《服务协议》</router-link>和
            <router-link to="protocol" style="color: #333333;text-decoration: none;" exact>《隐私保护》</router-link>
          </el-checkbox>
          <el-button plain :disabled="registerButtonFlag" class="spreader_login_5" :style="{
            background: (agreementChecked ? '#347BFF' : '#EEEEEE'),
            color: (agreementChecked ? '#FFFFFF' : '#B6B6B6')
          }" @click="register()">
            注册
          </el-button>
          <p
            style="display:block;width:100%;font-size: 16px;font-family: Microsoft YaHei;font-weight: 400;color: #BABABA;cursor: pointer;text-align: right;">
            已有账号，<span style="color: #347BFF" @click="setLoginStatus(0)">马上登录</span></p>
          <img width="64px" height="64px" src='../../assets/spreader/wechat.png' @click="setLoginStatus(2)"
            style="cursor:pointer;" />
          <p style="font-size: 14px;font-family: Microsoft YaHei;font-weight: 400;color: #7B7B7B;
          margin:10px 0 0 0;padding:0;cursor: pointer;" @click="setLoginStatus(2)">点击微信登录</p>
        </div>
      </div>
    </div>


    <el-dialog top="20%" class="imgCheckClass" :visible.sync="imageCheckShow" :show-close="false" width="310px">
      <div>
        <slide-verify :l="42" :r="10" :w="310" :h="155" slider-text="向右滑动" @success="onSuccess" @fail="onFail"
          @refresh="onRefresh"></slide-verify>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import qrcodeUrl from '../../config/wechat';
import wxlogin from 'vue-wxlogin';
import { login, tellogin,register } from '@/api/spreader/login';
import { updatepwdt, getTelCode } from '@/api/spreader/user';

export default {
  name: "spreader_login",
  components: {
    wxlogin
  },
  created() {
    this.status = 0;
    this.setLoginStatus(this.status);
    this.codeButtonStr = '获取验证码';
    this.isGet = false;
    this.codeTime = 60;

    //人机验证
    this.imageCheckShow = false;
    this.imageCheck = false;
  },
  destroyed: function () {
  },
  mounted: function () {
  },
  methods: {
    onSuccess() {
      this.imageCheckShow = false;
      this.imageCheck = true;
      this.getTelCode(this.telValue);
    },
    onFail() {
      this.imageCheckShow = true;
      this.imageCheck = false;
      console.log("onFail")
    },
    onRefresh() {
      console.log("onRefresh")
    },
    clickeUpdatePwd() {
      let data = {
        tel: this.telValue,
        pwd: this.forgetPwdPwd,
        code: this.forgetPwdCode,
      }
      return new Promise((resolve, reject) => {
        updatepwdt(data).then(res => {
          if (res.status == 200) {
            sessionStorage.removeItem("userInfo");
            this.setLoginStatus(1);
            this.$message('修改密码成功');
          } else {
            this.$message(res.message);
          }
        });
      })
    },
    pwdlogin() {
      let data = {
        tel: this.telValue,
        pwd: this.pwd
      }
      return new Promise((resolve, reject) => {
        login(data).then(res => {
          if (res.status == 200) {
            sessionStorage.setItem('userInfo', JSON.stringify(res.data));
            this.$router.push('/spreader/home');
          } else {
            this.$message(res.message);
          }
        });
      })
    },
    selectProtocolBox(value, e) {
      if (value) {
        this.registerButtonFlag = false;
      } else {
        this.registerButtonFlag = true;
      }
    },
    setLoginStatus(status) {
      this.status = status;
      if (status == 0) {
        this.codeLoginStyleConf = {
          color: '#347BFF'
        };
        this.codeLoginLineStyleConf = {
          background: '#347BFF'
        };
        this.pwdLoginStyleConf = {};
        this.pwdLoginLineStyleConf = {};
        this.title = '账号登陆';
      } else if (status == 1) {
        this.pwdLoginStyleConf = {
          color: '#347BFF'
        };
        this.pwdLoginLineStyleConf = {
          background: '#347BFF'
        };
        this.codeLoginStyleConf = {};
        this.codeLoginLineStyleConf = {};
        this.title = '账号登陆';
      } else if (status == 2) {
        this.title = '微信登录';
      } else if (status == 3) {
        this.title = '忘记密码';
      } else if (status == 4) {
        this.title = '注册';
      }
    },
    getTelCode(tel) {
      console.log(tel)
      if (!tel) {
        this.$message('请先输入手机号');
        return;
      }

      if (!this.imageCheck) {
        this.imageCheckShow = true;
        return;
      }

      if (this.isGet == false) {
        let data = {
          tel: tel
        }
        return new Promise((resolve, reject) => {
          getTelCode(data).then(res => {
            if (res.status == 200) {
              this.isGet = true
              this.telCodeInterval = setInterval(() => {
                if (this.codeTime == 0) {
                  this.isGet = false;
                  this.codeTime = 60;
                  this.codeButtonStr = '获取验证码';
                  clearInterval(this.telCodeInterval);
                } else {
                  this.codeTime = this.codeTime - 1;
                  this.codeButtonStr = this.codeTime + '重新发送';
                }
              }, 1000);
            } else {
              this.$message(res.message);
            }
          });
        })
      } else {
      }
    },
    tellogin() {
      let data = {
        tel: this.telValue,
        code: this.code
      }
      return new Promise((resolve, reject) => {
        tellogin(data).then(res => {
          if (res.status == 200) {
            sessionStorage.setItem('userInfo', JSON.stringify(res.data));
            this.$router.push('/spreader/home');
          } else {
            this.$message(res.message);
          }
        });
      })
    },
    register() {
      let data = {
        tel: this.telValue,
        code: this.registerCode,
        pwd: this.registerPwd
      }
      return new Promise((resolve, reject) => {
        register(data).then(res => {
          if (res.status == 200) {
            this.status = 0;
            this.$message('注册成功');
          } else {
            this.$message(res.message);
          }
        });
      })
    },

  },
  data() {
    return {
      imageCheckShow: false,
      imageCheck: false,

      forgetPwdCode: '',
      forgetPwdPwd: '',

      registerPwd: '',
      registerCode: '',
      registerButtonFlag: true,
      telValue: '',
      qrcodeUrl: qrcodeUrl,
      title: this.title,
      status: this.status,
      tel: '',
      pwd: '',
      code: '',
      flag: false,
      agreementChecked: false,
      codeButtonStr: '',
      codeLoginStyleConf: this.codeLoginStyleConf,
      codeLoginLineStyleConf: this.codeLoginLineStyleConf,
      pwdLoginStyleConf: this.pwdLoginStyleConf,
      pwdLoginLineStyleConf: this.pwdLoginLineStyleConf,
    };
  },
};
</script>

<style>
.spreader_login {
  background: url('../../assets/spreader/background.jpg') no-repeat center center;
}

.spreader_login_1:hover {
  color: #347BFF;
}

.spreader_login_1:hover .spreader_login_2 {
  background: #347BFF;
}

.spreader_login_3 {
  margin: 0;
  padding: 0;
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: 400;
}

.spreader_login_2 {
  margin: 10px 0 0 0;
  padding: 0;
  width: 40px;
  height: 4px;
}

.spreader_login_4 {
  background: url('../../assets/spreader/juxin3.png') no-repeat center center;
}

.spreader_login_5 {
  width: 100%;
  height: 52px;
  font-size: 24px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  margin-top: 35px;
}

.imgCheckClass .el-dialog__body {
  padding: 0;
}

.imgCheckClass .el-dialog__header {
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/spreader/login.vue